(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rd-product-details"] && !Shopify.designMode) return;
  try {
    

(() => {

  if (window.rdProductDetailsAccordionReady) {
    return;
  }

  window.rdProductDetailsAccordionReady = true;

  const SECTION_SELECTOR =
    '[data-rd-product-details]';

  const DATA_ACCORDION_SELECTOR =
    '.rd-product-details__data-accordion';

  const mobileQuery =
    window.matchMedia('(max-width: 899px)');


  /*
    Desktop:
    Specifications / Compatibility remain open so their
    tables behave like the existing sticky desktop column.

    Tablet / mobile:
    They begin closed and behave like normal accordions.
  */

  const syncDataAccordions = (
    root = document
  ) => {

    const sections = [];

    if (
      root.matches?.(
        SECTION_SELECTOR
      )
    ) {
      sections.push(root);
    }

    root
      .querySelectorAll?.(
        SECTION_SELECTOR
      )
      .forEach(
        (section) => {

          sections.push(section);

        }
      );


    sections.forEach(
      (section) => {

        section
          .querySelectorAll(
            DATA_ACCORDION_SELECTOR
          )
          .forEach(
            (details) => {

              if (mobileQuery.matches) {

                details.removeAttribute(
                  'open'
                );

              } else {

                details.setAttribute(
                  'open',
                  ''
                );

              }

            }
          );

      }
    );

  };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => syncDataAccordions(document),
      {
        once: true
      }
    );

  } else {

    syncDataAccordions(document);

  }


  if (
    typeof mobileQuery.addEventListener ===
    'function'
  ) {

    mobileQuery.addEventListener(
      'change',
      () => syncDataAccordions(document)
    );

  } else {

    mobileQuery.addListener(
      () => syncDataAccordions(document)
    );

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      syncDataAccordions(
        event.target
      );

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-product-reviews"] && !Shopify.designMode) return;
  try {
    

  (() => {
    if (window.rdProductReviewsReady) return;

    window.rdProductReviewsReady = true;

    let lastOpener = null;


    /* ======================================================
       STORAGE
       ====================================================== */

    const storageKey = (section) => {
      return `rd-product-reviews:v1:${section.dataset.productId}`;
    };


    const pendingKey = (section) => {
      return `${storageKey(section)}:pending`;
    };


    const readJSON = (key, fallback) => {
      try {
        const value = window.localStorage.getItem(key);

        if (!value) return fallback;

        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    };


    const writeJSON = (key, value) => {
      try {
        window.localStorage.setItem(
          key,
          JSON.stringify(value)
        );

        return true;
      } catch (error) {
        return false;
      }
    };


    const removeStorage = (key) => {
      try {
        window.localStorage.removeItem(key);
      } catch (error) {
        /* no-op */
      }
    };


    const getLocalReviews = (section) => {
      const reviews = readJSON(
        storageKey(section),
        []
      );

      if (!Array.isArray(reviews)) return [];

      return reviews;
    };


    const makeId = () => {
      if (
        window.crypto &&
        typeof window.crypto.randomUUID === 'function'
      ) {
        return window.crypto.randomUUID();
      }

      return `review-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`;
    };


    /* ======================================================
       DIALOG
       ====================================================== */

    const getDialog = (trigger) => {
      if (!trigger) return null;

      const id = trigger.dataset.rdReviewDialogId;

      if (!id) return null;

      return document.getElementById(id);
    };


    const openDialog = (dialog, trigger = null) => {
      if (!dialog) return;

      if (trigger) {
        lastOpener = trigger;
      }

      if (dialog.open) return;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };


    const closeDialog = (dialog) => {
      if (!dialog) return;

      if (
        typeof dialog.close === 'function' &&
        dialog.open
      ) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };


    /* ======================================================
       LOCAL REVIEW CARD
       ====================================================== */

    const createReviewCard = (review) => {
      const card = document.createElement('article');

      card.className = 'rd-product-reviews__card';
      card.dataset.rdLocalReview = review.id;


      const top = document.createElement('div');

      top.className = 'rd-product-reviews__card-top';


      const avatar = document.createElement('div');

      avatar.className = 'rd-product-reviews__avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.textContent =
        String(review.name || 'Customer')
          .trim()
          .charAt(0)
          .toUpperCase() || 'C';


      const reviewer = document.createElement('div');

      reviewer.className = 'rd-product-reviews__reviewer';


      const reviewerName = document.createElement('h3');

      reviewerName.textContent =
        review.name || 'Customer';


      const submittedState = document.createElement('div');

      submittedState.className =
        'rd-product-reviews__submission-state';

      submittedState.textContent = 'Submitted';


      reviewer.append(
        reviewerName,
        submittedState
      );

      top.append(
        avatar,
        reviewer
      );


      const stars = document.createElement('div');

      stars.className =
        'rd-product-reviews__card-stars';

      stars.setAttribute(
        'aria-label',
        `${review.rating} out of 5 stars`
      );


      for (let star = 1; star <= 5; star += 1) {
        const starElement =
          document.createElement('span');

        starElement.textContent = '★';
        starElement.setAttribute(
          'aria-hidden',
          'true'
        );

        if (star <= review.rating) {
          starElement.classList.add(
            'is-filled'
          );
        }

        stars.appendChild(starElement);
      }


      const body = document.createElement('div');

      body.className =
        'rd-product-reviews__body';

      body.textContent = review.body || '';


      const meta = document.createElement('div');

      meta.className =
        'rd-product-reviews__meta';


      const reviewed = document.createElement('span');

      let formattedDate = '';

      try {
        formattedDate =
          new Intl.DateTimeFormat(
            undefined,
            {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            }
          ).format(
            new Date(review.createdAt)
          );
      } catch (error) {
        formattedDate = 'Recently';
      }

      reviewed.textContent =
        `Reviewed ${formattedDate}`;

      meta.appendChild(reviewed);


      if (review.variant) {
        const separator =
          document.createElement('span');

        separator.setAttribute(
          'aria-hidden',
          'true'
        );

        separator.textContent = '·';


        const variant =
          document.createElement('span');

        variant.textContent =
          review.variant;


        meta.append(
          separator,
          variant
        );
      }


      card.append(
        top,
        stars,
        body,
        meta
      );

      return card;
    };


    /* ======================================================
       SUMMARY CALCULATION
       ====================================================== */

    const updateSummary = (
      section,
      localReviews
    ) => {
      const serverReviewCount =
        Number(
          section.dataset.serverReviewCount || 0
        );

      const serverRatingTotal =
        Number(
          section.dataset.serverRatingTotal || 0
        );

      const serverVerifiedCount =
        Number(
          section.dataset.serverVerifiedCount || 0
        );


      const counts = {
        1: Number(section.dataset.serverRating1 || 0),
        2: Number(section.dataset.serverRating2 || 0),
        3: Number(section.dataset.serverRating3 || 0),
        4: Number(section.dataset.serverRating4 || 0),
        5: Number(section.dataset.serverRating5 || 0)
      };


      let localRatingTotal = 0;


      localReviews.forEach((review) => {
        const rating = Number(review.rating);

        if (
          !Number.isFinite(rating) ||
          rating < 1 ||
          rating > 5
        ) {
          return;
        }

        localRatingTotal += rating;
        counts[rating] += 1;
      });


      const total =
        serverReviewCount +
        localReviews.length;


      const ratingTotal =
        serverRatingTotal +
        localRatingTotal;


      const summary =
        section.querySelector(
          '[data-rd-review-summary]'
        );

      const list =
        section.querySelector(
          '[data-rd-review-list]'
        );

      const empty =
        section.querySelector(
          '[data-rd-review-empty]'
        );


      if (total > 0) {
        summary.hidden = false;
        list.hidden = false;
        empty.hidden = true;
      } else {
        summary.hidden = true;
        list.hidden = true;
        empty.hidden = false;

        return;
      }


      const score =
        ratingTotal / total;


      const scoreElement =
        section.querySelector(
          '[data-rd-review-score]'
        );

      if (scoreElement) {
        scoreElement.textContent =
          score.toFixed(1);
      }


      const countText =
        section.querySelector(
          '[data-rd-review-count-text]'
        );


      if (countText) {
        const allVerified =
          localReviews.length === 0 &&
          serverReviewCount > 0 &&
          serverVerifiedCount ===
            serverReviewCount;

        const noun =
          total === 1
            ? 'review'
            : 'reviews';

        countText.textContent =
          `Based on ${total}${
            allVerified ? ' verified' : ''
          } ${noun}`;
      }


      for (let rating = 1; rating <= 5; rating += 1) {
        const row =
          section.querySelector(
            `[data-rd-rating-row="${rating}"]`
          );

        if (!row) continue;


        const percent =
          total > 0
            ? Math.round(
                (counts[rating] / total) *
                  100
              )
            : 0;


        const fill =
          row.querySelector(
            '[data-rd-rating-fill]'
          );

        const percentText =
          row.querySelector(
            '[data-rd-rating-percent]'
          );


        if (fill) {
          fill.style.setProperty(
            '--rd-review-percent',
            `${percent}%`
          );
        }


        if (percentText) {
          percentText.textContent =
            `${percent}%`;
        }
      }
    };


    /* ======================================================
       RENDER BROWSER REVIEWS
       ====================================================== */

    const renderLocalReviews = (section) => {
      const list =
        section.querySelector(
          '[data-rd-review-list]'
        );

      if (!list) return;


      list
        .querySelectorAll(
          '[data-rd-local-review]'
        )
        .forEach((card) => card.remove());


      const localReviews =
        getLocalReviews(section)
          .filter((review) => {
            return (
              review &&
              Number(review.rating) >= 1 &&
              Number(review.rating) <= 5
            );
          })
          .sort((a, b) => {
            return (
              new Date(b.createdAt).getTime() -
              new Date(a.createdAt).getTime()
            );
          });


      const fragment =
        document.createDocumentFragment();


      localReviews.forEach((review) => {
        fragment.appendChild(
          createReviewCard(review)
        );
      });


      list.insertBefore(
        fragment,
        list.firstChild
      );


      updateSummary(
        section,
        localReviews
      );
    };


    /* ======================================================
       COMMIT SUCCESSFUL SUBMISSION
       ====================================================== */

    const commitPendingReview = (section) => {
      const success =
        section.querySelector(
          '[data-rd-review-success]'
        );

      if (!success) return;


      const pending =
        readJSON(
          pendingKey(section),
          null
        );

      if (!pending) return;


      const reviews =
        getLocalReviews(section);


      const exists =
        reviews.some(
          (review) =>
            review.id === pending.id
        );


      if (!exists) {
        reviews.unshift(pending);

        writeJSON(
          storageKey(section),
          reviews.slice(0, 50)
        );
      }


      removeStorage(
        pendingKey(section)
      );
    };


    /* ======================================================
       INITIALISE SECTION
       ====================================================== */

    const initSection = (section) => {
      if (!section) return;


      commitPendingReview(section);

      renderLocalReviews(section);


      const result =
        section.querySelector(
          '[data-rd-review-autopen]'
        );


      if (result) {
        const dialog =
          result.closest(
            '[data-rd-review-dialog]'
          );

        openDialog(dialog);

        window.requestAnimationFrame(
          () => {
            result.scrollIntoView({
              block: 'nearest'
            });
          }
        );
      }
    };


    const initAll = (root = document) => {
      root
        .querySelectorAll(
          '[data-rd-product-reviews]'
        )
        .forEach(initSection);
    };


    /* ======================================================
       SAVE PENDING REVIEW BEFORE SHOPIFY SUBMITS
       ====================================================== */

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;

        if (
          !form.matches(
            '.rd-product-reviews__form'
          )
        ) {
          return;
        }


        const section =
          form.closest(
            '[data-rd-product-reviews]'
          );

        if (!section) return;


        const ratingInput =
          form.querySelector(
            'input[name="contact[Rating]"]:checked'
          );

        const nameInput =
          form.querySelector(
            'input[name="contact[name]"]'
          );

        const emailInput =
          form.querySelector(
            'input[name="contact[email]"]'
          );

        const orderInput =
          form.querySelector(
            'input[name="contact[Order number]"]'
          );

        const variantInput =
          form.querySelector(
            'input[name="contact[Variant or fitment]"]'
          );

        const bodyInput =
          form.querySelector(
            'textarea[name="contact[body]"]'
          );


        if (
          !ratingInput ||
          !nameInput ||
          !emailInput ||
          !bodyInput
        ) {
          return;
        }


        const review = {
          id: makeId(),

          name:
            nameInput.value.trim(),

          email:
            emailInput.value.trim(),

          rating:
            Number(ratingInput.value),

          order:
            orderInput
              ? orderInput.value.trim()
              : '',

          variant:
            variantInput
              ? variantInput.value.trim()
              : '',

          body:
            bodyInput.value.trim(),

          createdAt:
            new Date().toISOString()
        };


        writeJSON(
          pendingKey(section),
          review
        );
      }
    );


    /* ======================================================
       OPEN / CLOSE POPUP
       ====================================================== */

    document.addEventListener(
      'click',
      (event) => {

        const openButton =
          event.target.closest(
            '[data-rd-review-open]'
          );


        if (openButton) {
          event.preventDefault();

          openDialog(
            getDialog(openButton),
            openButton
          );

          return;
        }


        const closeButton =
          event.target.closest(
            '[data-rd-review-close]'
          );


        if (closeButton) {
          event.preventDefault();

          closeDialog(
            closeButton.closest(
              '[data-rd-review-dialog]'
            )
          );

          return;
        }


        if (
          event.target.matches &&
          event.target.matches(
            '[data-rd-review-dialog]'
          )
        ) {
          closeDialog(event.target);
        }
      }
    );


    document.addEventListener(
      'close',
      (event) => {
        if (
          !event.target.matches ||
          !event.target.matches(
            '[data-rd-review-dialog]'
          )
        ) {
          return;
        }


        if (
          lastOpener &&
          document.contains(lastOpener)
        ) {
          window.requestAnimationFrame(
            () => {
              lastOpener.focus({
                preventScroll: true
              });
            }
          );
        }
      },
      true
    );


    /* ======================================================
       START
       ====================================================== */

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initAll(document),
        {
          once: true
        }
      );
    } else {
      initAll(document);
    }


    /* ======================================================
       SHOPIFY THEME EDITOR
       ====================================================== */

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initAll(event.target);
      }
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-related-products"] && !Shopify.designMode) return;
  try {
    

(() => {

  const ROOT = '[data-rd-related-auto]';


  const loadAssets = (section) => {

    if (
      !section ||
      section.dataset.rdRelatedAssets === 'loaded'
    ) {
      return;
    }

    section.dataset.rdRelatedAssets = 'loaded';

    const css = section.dataset.rdCardCss;
    const js = section.dataset.rdCardJs;


    if (
      css &&
      !document.querySelector(
        'link[data-rd-product-card-css]'
      )
    ) {

      const link = document.createElement('link');

      link.rel = 'stylesheet';
      link.href = css;
      link.dataset.rdProductCardCss = '';

      document.head.appendChild(link);

    }


    if (
      js &&
      !window.__rdProductCardReady &&
      !document.querySelector(
        'script[data-rd-product-card-js]'
      )
    ) {

      const script = document.createElement('script');

      script.src = js;
      script.async = true;
      script.dataset.rdProductCardJs = '';

      document.head.appendChild(script);

    }

  };


  const init = (root = document) => {

    const sections = root.matches?.(ROOT)
      ? [root]
      : [...(root.querySelectorAll?.(ROOT) || [])];


    sections.forEach((section) => {

      if (
        section.dataset.rdRelatedReady === 'true'
      ) {
        return;
      }

      section.dataset.rdRelatedReady = 'true';


      if ('IntersectionObserver' in window) {

        const observer = new IntersectionObserver(
          (entries) => {

            if (
              !entries.some(
                (entry) => entry.isIntersecting
              )
            ) {
              return;
            }

            loadAssets(section);
            observer.disconnect();

          },
          {
            rootMargin: '400px 0px'
          }
        );

        observer.observe(section);

      } else {

        loadAssets(section);

      }

    });

  };


  document.addEventListener(
    'shopify:section:load',
    (event) => init(event.target)
  );


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );

  } else {

    init();

  }

})();


  } catch(e) { console.error(e); }
})();
})();
